import BackendDeveloperPage from "./BackendDeveloperPage";

export default function UnrealDeveloperPage() {
  return <BackendDeveloperPage technology="unreal" />;
}
